import * as searchConstants from '../../Constants/Search';
//Initial states for all reducers. these states will be returned when "undefined" is passed as second arguement to createStore function.
export default {
	search: {
		category: searchConstants.assets3dVal, //making the default selection to 3d assets
		options: [],
		selectedOption: {},
		searchTerm: '',
	},
	results: {
		assets3dData: {
			count: 0,
			data: [],
		},
		productsData: {
			count: 0,
			data: [],
		},
		assetFilters: {
			isBuyable: true,
			isArchived: false,
			tags: [],
		},
		productFilters: {
			isBuyable: true,
		},
		assetFilterCount: {
			archived: 0,
			buyable: 0,
		},
		productFilterCount: {
			buyable: 0,
		},
	},
	stepper: {
		steps: [],
		activeStep: 0,
	},

	//new create custom workflow assets
	assets: [],
	csvImportmissingIvms: [],
	//Assets which are reviewed and submitted to the backend (i.e successfully created assets)
	submittedAssets: [],
	tags: {
		options: [],
		selectedTags: [],
	},
	autoCompleteLoading: false,
	productsSearchOptions: [],
	ui: {
		snackBar: {
			open: false,
			severity: '',
			message: '',
		},
		dialog: {
			open: false,
			title: '',
			content: '',
			size: 'lg',
		},
		backDrop: {
			open: false,
			message: '',
		},
	},
	//Initial state for manage asset component
	manageAsset: {
		name: '',
		id: '',
		archived: '',
		barcode: '',
		jiraTask: '',
		createdAt: '',
		updatedAt: '',
		tags: [],
		product: {},
		sourceFiles: [],
		artifacts: [],
		alignment: {},
	},
	// Initial state for manage products component
	manageProduct: {
		uuid: '',
		name: '',
		// initial state for linked 3D assets for manage product.
		linkedAsset: {},
	},
	// this state holds the search term given by user on search page or results page.
	resultsViewSearchTerm: '',
	user: {
		userId: null, // Unique Id for the user
		displayName: null, // Pretty name for the user
		email: null, // Email if its exists
		username: null,
		token: {
			token_type: null,
			scope: null,
			expires_in: null,
			ext_expires_in: null,
			access_token: null,
			refresh_token: null,
			id_token: null,
		},
	},
	// this state represents the checkBox to Create Jira Ticket on Review & Create step of create asset workflow.
	shouldCreateJiraTicket: false,
	// this state tracks which menu item view (UploadCSV or Manual Entry) is currently active  .
	isCSVUploadViewLoaded: false,
};
